import { Employee } from "../types/Employee";
import { queryEmployee } from "./queryEmployee";

export const queryEmployeeFromStateOrDb = async (state: unknown, idNumber: string | undefined) => {
  if (!Boolean(state) || !(state as any).employee) {
    if (idNumber) {
      const d = await queryEmployee(idNumber);
      if (d) {
        if (d.supervisor)
          d.supervisorData = await queryEmployee(d.supervisor);
        if (d.chiefSupervisor)
          d.chiefSupervisorData = await queryEmployee(d.chiefSupervisor);
      }
      
      return d;
    }
    return undefined;
  } else {
    const d = ((state as any).employee) as Employee;
    if (d.supervisor)
      d.supervisorData = await queryEmployee(d.supervisor);
    if (d.chiefSupervisor)
      d.chiefSupervisorData = await queryEmployee(d.chiefSupervisor);
    return d;
  }
};  